module.exports = __webpack_public_path__ + "img/section3.609de53a.svg";